<template>
  <section>
      <v-card flat>
        <v-container class="pa-0 pb-fab">
          <v-row v-if="currentNotification">
            <v-col cols="12">
              <v-chip
                label
                v-if="currentNotification"
                :color="currentNotification.notification_type.backgroundColor"
                :text-color="currentNotification.notification_type.color">
                {{ currentNotification.notification_type.label }}
              </v-chip>
            </v-col>

            <v-col cols="12">
              <h4 style="margin:0; font-size: 14px;">{{ currentNotification.request.service.name }}</h4>
            </v-col>

            <v-col cols="12" style="padding-top:0;padding-bottom:0;">
              <v-row v-for="(item, i) in currentNotification.request.service.prices" :key="i">
                <v-col cols="6" md="10" style="padding-bottom:0">
                  <p style="margin:0">{{ item.text }}</p>
                </v-col>
                <v-col cols="6" md="2" style="padding-bottom:0">
                  <p style="margin:0" align="right">{{ item.value }}</p>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <p style="margin:0; font-size: 14px;">{{ currentNotification.request.description }}</p>
            </v-col>

            <v-col cols="12" class="pb0">
              <h4 style="margin:0; font-size: 14px;">Disponibilidad</h4>
            </v-col>

            <v-col cols="12" style="padding-top:0;padding-bottom:0;">
              <v-radio-group style="margin:0; font-size: 14px;" v-model="selectedAvailability">
                <v-row v-for="(item, i) in currentNotification.request.availability" :key="i">
                  <v-col cols="10" md="10" style="padding-bottom:0">
                    <p style="margin:0; font-size: 14px;">{{ getFormattedDate(item) }}</p>
                  </v-col>
                  <v-col cols="2" md="2" style="padding-bottom:0; display: flex; justify-content: flex-end;">
                    <v-radio
                      color="rapired"
                      :key="i"
                      :value="item.id"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>

            <v-col cols="12" class="pt0">
              <p style="margin:0; font-size: 14px;">Barrio {{ currentNotification.request.neighborhood.name }}</p>
            </v-col>
            <v-col cols="12" class="pt0">
              <p style="margin:0; font-size: 14px;">{{ currentNotification.request.neighborhood.city.name }}, {{ currentNotification.request.neighborhood.city.state.name }}</p>
            </v-col>

            <v-col cols="12" class="pb0">
              <h4 style="margin:0; font-size: 14px;">Métodos de pago</h4>
            </v-col>
            <v-col cols="12" class="pt0">
              <p style="margin:0; font-size: 14px;" class="m0" v-for="(item, i) in currentNotification.request.payment_methods" :key="i">{{ item.name }}</p>
            </v-col>

            <div class="bottom-bar">
              <v-row align="center">
                <v-col cols="6">
                  <v-btn @click="iAmNotInterested"  color="rapired" dark large>no me interesa</v-btn>
                </v-col>
                <v-col cols="6" class="menu-container">
                  <v-btn @click="iAmInterested" :disabled="!selectedAvailability" color="secondary" large>me interesa</v-btn>
                </v-col>
              </v-row>
            </div>

          </v-row>
        </v-container>
      </v-card>
  </section>
</template>
<script>
import moment from 'moment'

export default {
  name: 'notification-detail',

  data: () => ({
    currentNotification: null,
    selectedAvailability: null
  }),

  mounted () {
    this.currentNotification = this.$store.state.current_notification
    !this.currentNotification.id && this.$router.push('visit-list')
    // this.currentNotification.id && !this.currentNotification.read && this.markNotificationAsRead()
    this.$store.commit('set_app_title', this.currentNotification.title)
    window.scrollTo(0, 0)
  },
  
  methods: {
    getFormattedDate (av) {
      if (av.date_from && av.date_to) {
        const from = moment(av.date_from)
        const to = moment(av.date_to)
        let formatted = from.format('dddd DD MMMM')
        formatted += ', ' + from.format('HH:mm') + ' a ' + to.format('HH:mm')
        return formatted
      }
    },
    markNotificationAsRead () {
      this.axios.put(`notification/${this.currentNotification.id}/read/`).then(response => {
      })
    },
    showCheckInConfirmDialog () {
      this.checkInDialog = true
    },
    iAmInterested () {
      const body = {
        reply: true,
        availability: this.selectedAvailability
      }
      this.axios.put(`request_technician/${this.currentNotification.request_technician}/reply/`, body).then(response => {
        this.axios.delete(`notification/${this.currentNotification.id}/`).then(response => {
          this.$store.commit('show_alert', 'Se ha marcado como Interesado')
          this.$router.push('notification-list')
        })
      })
    },
    iAmNotInterested () {
      const body = {
        reply: false
      }
      this.axios.put(`request_technician/${this.currentNotification.request_technician}/reply/`, body).then(response => {
        this.axios.delete(`notification/${this.currentNotification.id}/`).then(response => {
          this.$store.commit('show_alert', 'Se ha marcado como No Interesado')
          this.$router.push('notification-list')
        })
      })
    }
  }
}
</script>

<style scoped>
.menu-container {
  display: flex;
  justify-content: flex-end;
}
.pb-fab {
  padding-bottom: 108px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.in-bl{
  display: inline-block;
}
.icon-cont {
  display: flex;
  justify-content: flex-end;
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100px;
}
.fab-but-cont {
  display: flex;
  justify-content: flex-start;
}
</style>
